const card = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryContentDetail({ rootState }, params = {}) {
      const data = await rootState.http("/learn/content/getLearnContentTextDetail", params);
      return data;
    }
  }
};

export default card;



// WEBPACK FOOTER //
// ./src/store/modules/learning.js